/* eslint-disable no-param-reassign */
import { updateProgressStep, updateCurrentView } from './utils/ProgressStep';
import {
  getSession,
  setSession,
  getLTEUpgrade,
  isLoggedIn,
  isExpressCheckout,
  getUrlName,
  isSelfSetupSelected,
} from './components/common/Helpers/index';
import history from './utils/history';

export const redirectTo = (modelRootPath, hist) => {
  if (!hist) hist = history;

  let url = modelRootPath;
  if (!url?.includes('sales/home')) {
    url = `/sales/home/${url}`;
  }
  if (hist?.location?.search === '?smlpLQ=Y&mvp-smlp=Y') {
    window.location.href = url;
  } else {
    return hist.push(url);
  }
};

const getPlansPage = (streamlineMVP2) => (streamlineMVP2 ? 'streamlineordering.html' : 'progressiveplan.html');

export const goToProcessStep = (process, hist = null, isEdit, isNoSlotsAvailable, isPlansEdit, isSetupEdit, isPerksEdit, isAddonsEdit) => {
  const orderSubmitted = getSession('OrderSubmitted');
  const isEditFromCart = getSession('isEditFromCart');
  const streamlineMVP2 = window.sessionStorage.getItem('widgetLQHost') === 'Streamline';
  const ProgressiveStreamline = streamlineMVP2 ? 'streamlineordering.html' : 'progressiveplan.html';
  if (isEditFromCart === 'Y') {
    setSession('isEditFromCart', 'N');
  }
  if (isEdit) {
    setSession('isEditFromCart', 'Y');
    updateProgressStep(process.editStep, true);
    redirectTo(process.editPage, hist);
  } else if (isPlansEdit) {
    setSession('isPlansEdit', 'Y');
    setSession('isPerksEdit', 'N');
    setSession('isPlanSelect', 'N');
    updateProgressStep(ProgressiveStreamline, true);
    window.location.href = ProgressiveStreamline;
  } else if (isSetupEdit) {
    setSession('isSetupEdit', 'Y');
    updateProgressStep(process.previousStep, true);
    redirectTo(process.editSetupPage, hist);
  } else if (isNoSlotsAvailable) {
    setSession('isNoSlotsAvailable', 'Y');
    updateProgressStep(process.noSLotsStep, true);
    if (isLoggedIn() && getSession('changeToSelf') === 'Y') {
      if (isExpressCheckout()) {
        updateProgressStep(process.TOSEXPRESS.noSLotsStep, true);
        redirectTo(process.TOSEXPRESS.noSLots, hist);
      } else {
        window.location.href = process.noSLots;
      }
    } else {
      redirectTo(process.noSLots, hist);
    }
  } else if (isPerksEdit) {
    setSession('isPerksEdit', 'Y');
    setSession('isPlansEdit', 'N');
    const plansPage = getPlansPage(streamlineMVP2);
    updateProgressStep(plansPage, true);
    window.location.href = plansPage;
  } else if (isAddonsEdit) {
    setSession('isAddonsEdit', 'Y');
    updateProgressStep(process.editAddonsStep, true);
    redirectTo(process.editAddonsStep, hist);
  } else if (orderSubmitted !== 'Y' && process) {
    let { nextStep, nextViewPage } = process;
    if (nextStep === 'Addons' && getLTEUpgrade()) {
      // skip setup step for LTE
      nextStep = 'Cart';
      nextViewPage = 'cart.html';
    } else if (nextStep === 'ContactInfo' && isLoggedIn()) {
      // skip contact info step for logged in user - OrderReview / Shipping
      const isSelfSetup = isSelfSetupSelected();
      if (isSelfSetup) {
        nextStep = 'Shipping';
        nextViewPage = 'shipping.html';
      } else {
        nextStep = 'OrderReview';
        nextViewPage = 'orderreview.html';
      }
    }

    updateProgressStep(nextStep, true);
    redirectTo(nextViewPage, hist);
  } else if (orderSubmitted === 'Y') {
    redirectTo(`${String?.protoType?.toLowercase(process.currentStep)}.html`, hist);
  } else {
    const pageName = hist?.location ? getUrlName(hist.location.pathname) : '';
    const pathName = orderSubmitted !== 'Y' && pageName ? pageName : 'confirmation';
    updateCurrentView(pathName, hist);
  }
};

export const updateProcessOnBrowserAction = (location) => {
  const orderSubmitted = getSession('OrderSubmitted');
  const pageName = orderSubmitted !== 'Y' ? getUrlName(location.pathname) : 'confirmation';

  if (pageName) {
    updateProgressStep(pageName, true);
  }
};
